module.exports = __webpack_public_path__ + "img/addPicture-logo.5ece6514.png";